import { render, staticRenderFns } from "./BalanceTransDetails.vue?vue&type=template&id=12b5c25e&scoped=true"
import script from "./BalanceTransDetails.vue?vue&type=script&lang=js"
export * from "./BalanceTransDetails.vue?vue&type=script&lang=js"
import style0 from "./BalanceTransDetails.vue?vue&type=style&index=0&id=12b5c25e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b5c25e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b5c25e')) {
      api.createRecord('12b5c25e', component.options)
    } else {
      api.reload('12b5c25e', component.options)
    }
    module.hot.accept("./BalanceTransDetails.vue?vue&type=template&id=12b5c25e&scoped=true", function () {
      api.rerender('12b5c25e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/financials-agent/components/Balance/BalanceTransDetails.vue"
export default component.exports